import {
    Dialog,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from '@mui/material'
import { snakeCaseToPascalCase } from '@utils'

type Props = {
    onClose(): void
    selectedRow: Record<string, any> | null
}

const SelectedRowDetailsDialog = (props: Props) => {
    const { onClose, selectedRow } = props

    return (
        <Dialog onClose={onClose} open={!!selectedRow}>
            <DialogContent>
                {selectedRow !== null && (
                    <Table size="small">
                        <TableBody>
                            {Object.entries(selectedRow).map(([key, value]) => {
                                return (
                                    <TableRow>
                                        <TableCell>
                                            {snakeCaseToPascalCase(key)}
                                        </TableCell>
                                        <TableCell>
                                            <strong>{value}</strong>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default SelectedRowDetailsDialog
